import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgGridModule } from '../angular2-grid/modules/NgGrid.module';

import { HttpClientModule } from '@angular/common/http';
//import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { rootRouterConfig } from './app.routes';
import { LoginComponent } from "./login.component/login.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ErrorHandler } from '@angular/core';
import { DashboardConfigManager, ParameterService,CommonService, NotificationService, AuthService, WsiUtilityService, SignalRService, WSIValueService, EventCounterService, LogService, WidegtHelperService,PmBarchartDataService,PmPropertyDescriptionService } from 'core-dashboard';
import { HttpClient } from '@angular/common/http';
// import { dashboardprovider } from 'dashboard-providers';
import { HomeComponent } from './home.component/home.component';
import { DashboardMain} from './main/app.component';
import { WidgetPlaceholder } from './widget.placeholder.component/widget.placeholder.component';
import {ComponentResolver} from './ComponentResolverService';


  @NgModule({
    imports: [
      CommonModule,
      BrowserModule,
      FormsModule,
      NgGridModule,
      HttpClientModule,
      
      // dashboardprovider,
      
      RouterModule.forRoot(rootRouterConfig),    
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http, "./i18n/", ".json"),
          deps: [HttpClient]
        }, isolate: true
      })
    ],
    declarations: [DashboardMain, HomeComponent, WidgetPlaceholder, LoginComponent],
    providers: [DashboardConfigManager,
      ParameterService, NotificationService,
      AuthService,
      CommonService,
      WsiUtilityService,
      SignalRService,
      WSIValueService,
      EventCounterService,
      LogService,
      WidegtHelperService,
      ComponentResolver,
      PmBarchartDataService,
      PmPropertyDescriptionService],
    bootstrap: [DashboardMain],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
  })
  

   //public dynamicModule : NgModule
   export class AppModule{
   constructor()
    {
      //var dynamicModule1 = modulesArray[0];
      //var horizantalChart = dynamicModule1.HorizontalBarChart;      
      //this.dynamicModule =  modulesArray[0];
      //HomeComponent.DynamicWidgetCollection = this.dynamicModule;
     // ComponentResolver.forRoot(modules.components);
     
    }

  }
  
  

